import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';

import RehearsalTimeline from 'components/Details/RehearsalTimeline.tsx';
import bostonTrim from "gallery/boston-trim.png";

 export default function Rehearsal() {
  return (
    <Box sx={{
      py: 3,
      px: {xs: 0, md: 3},
      alignSelf:"center",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      display: 'flex',
    }}>
      <Card sx={{ 
          maxWidth: 800,
          width: "100%",
          backgroundColor: "#ffeedd",
          display: 'flex', 
          flexDirection: "column",
        }}>
        <CardHeader 
          title="Rehearsal" 
          titleTypographyProps = {{variant: "h4"}}
          />
        <CardMedia
          sx={{ 
            width: "100%",
            objectFit: "contain",
          }}
          component="img"
          image={bostonTrim}
          title="Detailed Information"
        />
        <CardContent>
          <RehearsalTimeline />
        </CardContent>
      </Card>
    </Box>
  );
}
